const ROLLOUTS = {
    QUALAS_NEW_LEVEL_SYSTEM: 'qualas_new_level_system_consumers_migration',
};

module.exports = {
    ROLLOUTS,
};
